// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles-module__fieldset___1CuTp","legend":"styles-module__legend___2PAAx"};